var _path, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglepay(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20317_66002)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_20317_66002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8976 11.7214V14.8946H15.874V7.04688H18.5354C19.1837 7.04688 19.7979 7.28572 20.2756 7.72929C20.7533 8.13874 20.9921 8.75291 20.9921 9.40121C20.9921 10.0495 20.7533 10.6296 20.2756 11.0731C19.7979 11.5167 19.2179 11.7555 18.5354 11.7555L16.8976 11.7214ZM16.8976 8.00226V10.7319H18.6037C18.979 10.7319 19.3543 10.5954 19.5932 10.3225C20.1391 9.81065 20.1391 8.95764 19.6273 8.44583L19.5932 8.4117C19.3202 8.13874 18.979 7.96813 18.6037 8.00226H16.8976Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3465 9.36719C24.0972 9.36719 24.6772 9.57191 25.1208 9.98136C25.5644 10.3908 25.7691 10.9367 25.7691 11.6192V14.8947H24.8137V14.1441H24.7796C24.3701 14.7583 23.7901 15.0654 23.1077 15.0654C22.5276 15.0654 22.0158 14.8947 21.6064 14.5535C21.231 14.2123 20.9922 13.7346 20.9922 13.2228C20.9922 12.6769 21.1969 12.2333 21.6064 11.8921C22.0158 11.5509 22.5959 11.4144 23.2783 11.4144C23.8925 11.4144 24.3701 11.5168 24.7455 11.7556V11.5168C24.7455 11.1756 24.609 10.8344 24.336 10.6297C24.0631 10.3908 23.7218 10.2543 23.3465 10.2543C22.7665 10.2543 22.3229 10.4932 22.0158 10.9709L21.1287 10.4249C21.6746 9.70839 22.3911 9.36719 23.3465 9.36719ZM22.0499 13.257C22.0499 13.5299 22.1864 13.7688 22.3911 13.9052C22.63 14.0758 22.9029 14.1782 23.1759 14.1782C23.5854 14.1782 23.9948 14.0076 24.3019 13.7005C24.6431 13.3934 24.8137 13.0181 24.8137 12.6087C24.5066 12.3698 24.0631 12.2333 23.483 12.2333C23.0736 12.2333 22.7323 12.3357 22.4594 12.5404C22.1864 12.711 22.0499 12.9499 22.0499 13.257Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2967 9.53809L27.9187 17.2835H26.8951L28.1575 14.588L25.9397 9.57221H27.0316L28.6352 13.4279H28.6694L30.2389 9.57221H31.2967V9.53809Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8372 11.0394C12.8372 10.7323 12.8031 10.4253 12.769 10.1182H8.50391V11.8583H10.9265C10.8241 12.4043 10.517 12.9161 10.0393 13.2232V14.3491H11.5065C12.3595 13.5644 12.8372 12.4043 12.8372 11.0394Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50403 15.441C9.73238 15.441 10.756 15.0315 11.5067 14.3491L10.0395 13.2231C9.63001 13.4961 9.1182 13.6667 8.50403 13.6667C7.34393 13.6667 6.3203 12.8819 5.9791 11.79H4.47778V12.9501C5.26256 14.4856 6.79799 15.441 8.50403 15.441Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97899 11.7899C5.77426 11.244 5.77426 10.6298 5.97899 10.0498V8.88965H4.47768C3.82938 10.1521 3.82938 11.6534 4.47768 12.95L5.97899 11.7899Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50384 8.20775C9.15214 8.20775 9.76631 8.4466 10.244 8.89017L11.5406 7.59358C10.7217 6.84293 9.62983 6.39936 8.53797 6.43348C6.83193 6.43348 5.26237 7.38886 4.51172 8.92429L6.01303 10.0844C6.32012 8.99253 7.34374 8.20775 8.50384 8.20775Z",
    fill: "#EA4335"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20317_66002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_20317_66002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2966,
    height: 13,
    fill: "white",
    transform: "translate(4 5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglepay);
export default __webpack_public_path__ + "static/media/googlepay.92440a94ab5a8577d3e6003f29ed8d52.svg";
export { ForwardRef as ReactComponent };